import { IFireAgencyState, actionTypes } from 'src/ducks/fire-agency.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getFireAgencyStatus = (
  state: IFireAgencyState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
